export default {
      id: "icon-twopeople-usage",
      viewBox: "0 0 38 26",
      url: __webpack_public_path__ + "icons.svg#icon-twopeople",
      toString: function () {
        return this.url;
      }
    }